<template>
  <generic-container :title="$t('professor detail')" icon="student">
    <div class="ui icon warning message" v-if="!sections.length">
      <i class="student icon"></i>
      <div class="content">
        <div class="header">
          {{ $t("no sections assigned") }}
        </div>
        <p>{{ $t("this professor has no sections assigned") }}</p>
      </div>
    </div>
    <table class="ui celled table" ref="table" v-else>
      <thead>
        <tr>
          <th>{{ $t("course") }}</th>
          <th>{{ $t("section name") }}</th>
          <th>{{ $t("schedule") }}</th>
          <th>{{ $t("branch") }}</th>
          <th>{{ $t("studying time") }}</th>
          <th>{{ $t("students") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(section, sidx) in calculated_sections" :key="sidx">
          <td>
            {{ section.crs_course.name }}
          </td>
          <td>{{ section.name }}</td>
          <td v-bind:class="{ error: section.setup.schedule_duplicated }">
            {{ section.setup.schedule }}
          </td>
          <td>{{ section.std_branch.name }}</td>
          <td>{{ section.std_studying_time.name }}</td>
          <td
            v-bind:class="{
              positive:
                section.preinscriptions.length ==
                section.crs_assignation_students.length,
              negative:
                section.preinscriptions.length !=
                section.crs_assignation_students.length,
            }"
          >
            <ul>
              <li>
                <b>{{ section.preinscriptions.length }}</b>
                {{ $t("pre-assigned") }}
              </li>
              <li>
                <b>{{
                  section.crs_assignation_students
                    ? section.crs_assignation_students.length
                    : ""
                }}</b>
                {{ $t("assigned") }}
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </generic-container>
</template>

<script>
import { enterprise_setup, local_api, error_toast } from "@/utils";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "CourseAssignationDistributionRevisionTeacherBasedPicker",
  components: { GenericContainer },
  props: { professors: Array },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
    calculated_sections() {
      let vm = this;
      return vm.sections.map((s) => {
        s.setup.schedule_duplicated = vm.sections.find(
          (sc) => sc.setup.schedule == s.setup.schedule && sc.uuid != s.uuid,
        )
          ? true
          : false;
        return s;
      });
    },
  },
  data() {
    return { teacherFilter: "", selected: undefined, sections: [] };
  },
  methods: {
    select_professor(professor) {
      let vm = this;
      vm.selected = professor;

      /**
       * Get courses of this professor for the specified season
       */
      let distribution_uuid = this.$route.query.i;
      if (distribution_uuid) {
        local_api(
          vm,
          "post",
          "/course/assignation_professor_based/do-get-professor-courses",
          {
            u: distribution_uuid,
            p: professor.uuid,
          },
        )
          .then((sections) => {
            vm.sections = sections
              .map((s) => {
                s.preinscriptions = s.crs_assignation_preinscriptions;
                if (s && s.crs_course)
                  s.crs_course.course_id = String(s.crs_course.course_id);
                return s;
              })
              .sort((x) => x.setup.schedule);

            setTimeout(() => {
              window.jQuery(vm.$refs.tabs).find(".item").tab();
            }, 500);
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(this.$t("no course distribution found"));
      }
    },
  },
  created() {},
  mounted() {
    // let vm = this;
    // vm.init();
  },
};
</script>
